import * as d3 from "d3";

export default class ColorGenerator {
    // Public:
    constructor(cParams) {
        this.saveParams(cParams);
    }

    compute() {
        let color = this._color;
        const type = this.getColorType(color);
        switch (type) {
            case "string":
                switch (color) {
                    case "ordinal":
                        this.setOrdinalScaleFunction();
                        break;
                    default:
                        this.setStringReturnFunction();
                        break;
                }
                break;
            case "rgb":
                this.setRgbFunction();
                break;
            case "rgbList":
                this.setRgbListFunction();
                break;
            case "listOfStrings":
                if (this.stringsContainRgb(color)) {
                    color = this.convertStringListToRgb(color);
                    this._color = color;
                }
                this.setRgbListFunction();
                break;
            default:
                Error("Invalid color type.");
        }
        return this._func;
    }

    // Private:
    saveParams(cParams) {
        this._color = cParams.color;
    }

    setOrdinalScaleFunction() {
        this._func = d3.scaleOrdinal(d3.schemeCategory10);
    }

    setStringReturnFunction() {
        let color = this._color;
        this._func = () => color;
    }

    setRgbFunction() {
        let color = this._color;
        this._func = () => d3.rgb(color[0], color[1], color[2]);
    }

    setRgbListFunction() {
        const colorList = this._color;
        const N = colorList.length;
        const getColorFromGroup = group => {
            const i = group % N;
            return colorList[i];
        };
        this._func = groups => {
            let color = null;
            if (typeof groups === "object") {
                if (groups.length > 1) {
                    let colors = [];
                    for (let i = 0; i < groups.length; i++) {
                        const group = groups[i];
                        let c = getColorFromGroup(group);
                        colors.push(c);
                    }
                    color = this.combineColors(colors);
                } else {
                    color = getColorFromGroup(groups);
                }
            } else {
                color = getColorFromGroup(groups);
            }
            if (color !== null && color !== undefined) return d3.rgb(color[0], color[1], color[2]);
        };
    }

    getColorType(color) {
        let type = typeof color;
        if (type === "object") {
            if (color.length > 0) {
                const first = color[0];
                const subType = this.getColorType(first);
                if (subType === "number") type = "rgb";
                else if (subType === "string") type = "listOfStrings";
                else if (subType === "rgb") type = "rgbList";
            }
        }
        return type;
    }

    combineColors(colors) {
        let color = [0, 0, 0];
        const N = colors.length;
        colors.forEach(c => {
            color[0] += c[0];
            color[1] += c[1];
            color[2] += c[2];
        });
        color = color.map(a => Math.round(a / N));
        return color;
    }

    stringsContainRgb(stringList) {
        if (stringList.length > 0) {
            let first = stringList[0];
            return first.toLowerCase().includes("rgb(") && first.toLowerCase().includes(")");
        }
        return false;
    }

    convertStringListToRgb(stringList) {
        try {
            let vectList = [];
            stringList.forEach(string => {
                let vect = string
                    .split("(")[1]
                    .split(")")[0]
                    .split(",")
                    .map(s => parseInt(s));
                vectList.push(vect);
            });
            return vectList;
        } catch (error) {
            console.error("Invalid color format: " + stringList[0]);
            return [[0, 0, 0]];
        }
    }
}
